import hero from '../../../../assets/images/image.png';

export default function Hero() {
  return (
    <div>
      <img src={hero} alt='jara terrace menu' className='w-full' />
    </div>
  );
}
